import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  color: string;
}

export const Root = styled.div`
  margin-top:5px;
  display: flex;
  flex-direction: column;
`;


export const SearchContainer = styled.div`
  max-width: 281px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  position:relative;  
`;


export const FilterContainer = styled.div`
  display:inline-block;
`;

export const ButtonFilter = styled.button`
  height: 30px;
  font-size: 16px;
  text-align: left;
  color: ${C.LIGHT_GRAY};  
  border: unset;
  border-left: 1px solid ${C.LIGHT_GRAY};
  display:inline-block;
  background-color: #ffffff;
  cursor: pointer;
  margin: 0px 0px 0px 10px;
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
    background-color: #f5f5f5;
    border-radius: 5px;
  } 
  &:focus {
      outline: none;
  }
`


export const SearchChipsContainer = styled.div`
  max-width: 281px;
  min-height: 70px;
  width: auto;
  position:relative;
`;


export const SearchText = styled.div`
font-family: Roboto;
font-size: 14px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: center;
color: rgba(141, 141, 141, 0.5);
position:absolute;
top: 50%; left: 50%;
transform: translate(-50%,-50%);
width:160px;
`;



export const Col = styled.div`
  width: 300px;
  display:inline-block;  
  position:relative;
`;

export const InputSearch = styled.input`
  height: 48px;
  font-size: 16px;
  text-align: left;
  color: ${C.LIGHT_GRAY};
  padding: 0px 26px 0px 16px;
  border: unset;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &::placeholder {
    color: ${C.LIGHT_GRAY};
  }
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
  }
  &:focus {
        outline: none;
  }
`

export const Icon = styled.div`
  position: absolute;
  top: 15px;
  right: 14px;
  cursor: pointer;
`;

export const SearchList = styled.div`
  width: 100%;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 51;
  margin-top: 7px; 
`;

export const OptionsContaine = styled.div`
  height: auto;
  max-height: 220px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const Option = styled.div`
  width: auto;
  height: 19px;
  flex-grow: 0;
  padding: 8px 16px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgba(39, 39, 39, 0.5);
  cursor:pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  text-transform: capitalize;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Tag = styled.span`
  display: inline-block;
  color: ${(props: IProps) => props.color ? props.color :  "rgba(39, 39, 39, 0.5)"};
  text-transform: capitalize;
  margin-left: 4px;
`;